module.exports = __webpack_public_path__ + "static/media/rcl-nla.7fb0160b.png";